/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Born_Yummy_Emu_AdviseInputs */

const fr_born_yummy_emu_advise = /** @type {(inputs: Born_Yummy_Emu_AdviseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une section`)
};

/**

* @param {Born_Yummy_Emu_AdviseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const born_yummy_emu_advise = /** @type {((inputs?: Born_Yummy_Emu_AdviseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Born_Yummy_Emu_AdviseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_born_yummy_emu_advise(inputs)
});